/**
    This file is autogenerated using the command `yarn app-store:build --watch`.
    Don't modify this file manually.
**/
import { appDataSchema as alby_zod_ts } from "./alby/zod";
import { appDataSchema as basecamp3_zod_ts } from "./basecamp3/zod";
import { appDataSchema as btcpayserver_zod_ts } from "./btcpayserver/zod";
import { appDataSchema as closecom_zod_ts } from "./closecom/zod";
import { appDataSchema as dailyvideo_zod_ts } from "./dailyvideo/zod";
import { appDataSchema as databuddy_zod_ts } from "./databuddy/zod";
import { appDataSchema as dub_zod_ts } from "./dub/zod";
import { appDataSchema as fathom_zod_ts } from "./fathom/zod";
import { appDataSchema as feishucalendar_zod_ts } from "./feishucalendar/zod";
import { appDataSchema as ga4_zod_ts } from "./ga4/zod";
import { appDataSchema as giphy_zod_ts } from "./giphy/zod";
import { appDataSchema as googlecalendar_zod_ts } from "./googlecalendar/zod";
import { appDataSchema as googlevideo_zod_ts } from "./googlevideo/zod";
import { appDataSchema as gtm_zod_ts } from "./gtm/zod";
import { appDataSchema as hitpay_zod_ts } from "./hitpay/zod";
import { appDataSchema as hubspot_zod_ts } from "./hubspot/zod";
import { appDataSchema as insihts_zod_ts } from "./insihts/zod";
import { appDataSchema as intercom_zod_ts } from "./intercom/zod";
import { appDataSchema as jelly_zod_ts } from "./jelly/zod";
import { appDataSchema as jitsivideo_zod_ts } from "./jitsivideo/zod";
import { appDataSchema as larkcalendar_zod_ts } from "./larkcalendar/zod";
import { appDataSchema as lyra_zod_ts } from "./lyra/zod";
import { appDataSchema as make_zod_ts } from "./make/zod";
import { appDataSchema as matomo_zod_ts } from "./matomo/zod";
import { appDataSchema as metapixel_zod_ts } from "./metapixel/zod";
import { appDataSchema as mock_payment_app_zod_ts } from "./mock-payment-app/zod";
import { appDataSchema as nextcloudtalk_zod_ts } from "./nextcloudtalk/zod";
import { appDataSchema as office365calendar_zod_ts } from "./office365calendar/zod";
import { appDataSchema as office365video_zod_ts } from "./office365video/zod";
import { appDataSchema as paypal_zod_ts } from "./paypal/zod";
import { appDataSchema as pipedrive_crm_zod_ts } from "./pipedrive-crm/zod";
import { appDataSchema as plausible_zod_ts } from "./plausible/zod";
import { appDataSchema as posthog_zod_ts } from "./posthog/zod";
import { appDataSchema as qr_code_zod_ts } from "./qr_code/zod";
import { appDataSchema as routing_forms_zod_ts } from "./routing-forms/zod";
import { appDataSchema as salesforce_zod_ts } from "./salesforce/zod";
import { appDataSchema as shimmervideo_zod_ts } from "./shimmervideo/zod";
import { appDataSchema as stripepayment_zod_ts } from "./stripepayment/zod";
import { appDataSchema as tandemvideo_zod_ts } from "./tandemvideo/zod";
import { appDataSchema as booking_pages_tag_zod_ts } from "./templates/booking-pages-tag/zod";
import { appDataSchema as event_type_app_card_zod_ts } from "./templates/event-type-app-card/zod";
import { appDataSchema as twipla_zod_ts } from "./twipla/zod";
import { appDataSchema as umami_zod_ts } from "./umami/zod";
import { appDataSchema as vital_zod_ts } from "./vital/zod";
import { appDataSchema as webex_zod_ts } from "./webex/zod";
import { appDataSchema as wordpress_zod_ts } from "./wordpress/zod";
import { appDataSchema as zapier_zod_ts } from "./zapier/zod";
import { appDataSchema as zoho_bigin_zod_ts } from "./zoho-bigin/zod";
import { appDataSchema as zohocalendar_zod_ts } from "./zohocalendar/zod";
import { appDataSchema as zohocrm_zod_ts } from "./zohocrm/zod";
import { appDataSchema as zoomvideo_zod_ts } from "./zoomvideo/zod";
export const appDataSchemas = {
  alby: alby_zod_ts,
  basecamp3: basecamp3_zod_ts,
  btcpayserver: btcpayserver_zod_ts,
  closecom: closecom_zod_ts,
  dailyvideo: dailyvideo_zod_ts,
  databuddy: databuddy_zod_ts,
  dub: dub_zod_ts,
  fathom: fathom_zod_ts,
  feishucalendar: feishucalendar_zod_ts,
  ga4: ga4_zod_ts,
  giphy: giphy_zod_ts,
  googlecalendar: googlecalendar_zod_ts,
  googlevideo: googlevideo_zod_ts,
  gtm: gtm_zod_ts,
  hitpay: hitpay_zod_ts,
  hubspot: hubspot_zod_ts,
  insihts: insihts_zod_ts,
  intercom: intercom_zod_ts,
  jelly: jelly_zod_ts,
  jitsivideo: jitsivideo_zod_ts,
  larkcalendar: larkcalendar_zod_ts,
  lyra: lyra_zod_ts,
  make: make_zod_ts,
  matomo: matomo_zod_ts,
  metapixel: metapixel_zod_ts,
  "mock-payment-app": mock_payment_app_zod_ts,
  nextcloudtalk: nextcloudtalk_zod_ts,
  office365calendar: office365calendar_zod_ts,
  office365video: office365video_zod_ts,
  paypal: paypal_zod_ts,
  "pipedrive-crm": pipedrive_crm_zod_ts,
  plausible: plausible_zod_ts,
  posthog: posthog_zod_ts,
  qr_code: qr_code_zod_ts,
  "routing-forms": routing_forms_zod_ts,
  salesforce: salesforce_zod_ts,
  shimmervideo: shimmervideo_zod_ts,
  stripe: stripepayment_zod_ts,
  tandemvideo: tandemvideo_zod_ts,
  "booking-pages-tag": booking_pages_tag_zod_ts,
  "event-type-app-card": event_type_app_card_zod_ts,
  twipla: twipla_zod_ts,
  umami: umami_zod_ts,
  vital: vital_zod_ts,
  webex: webex_zod_ts,
  wordpress: wordpress_zod_ts,
  zapier: zapier_zod_ts,
  "zoho-bigin": zoho_bigin_zod_ts,
  zohocalendar: zohocalendar_zod_ts,
  zohocrm: zohocrm_zod_ts,
  zoomvideo: zoomvideo_zod_ts,
};
